import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { GetInvoiceStatisticsQuerySchema } from "@msuite/utils/schemas";
import { client } from "@/hono";

export function useInvoiceStatistics(query: GetInvoiceStatisticsQuerySchema) {
	/** Query */
	const { data: statistics, ...rest } = useQuery({
		queryKey: ["invoice-statistics", JSON.stringify(query)],
		queryFn: async () => {
			const response = await client.statistics.invoices.$get({ query });
			const data = await responseHandler(response);
			return data.statistics;
		},
	});

	/** Return */
	return { statistics, ...rest };
}
